import { createFileRoute } from '@tanstack/react-router'
import { IndustriesPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/industries')({
  head: ({ params }) => localizedPageHead('industries', params.locale),
  component: () => <IndustriesPage />,
})
